import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE } from "../api/api";

export default function MFASMS() {
  const location = useLocation();
  const navigate = useNavigate();
  const [email] = React.useState(
    () => location.state?.email || localStorage.getItem("mfa_email") || ""
  );
  const [sessionId] = React.useState(
    () => location.state?.sessionId || localStorage.getItem("mfa_session") || ""
  );
  const [code, setCode] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [sent, setSent] = React.useState(false);

  React.useEffect(() => {
    if (!email || !sessionId) navigate("/login");
  }, [email, sessionId, navigate]);

  const sendCode = async () => {
    setError("");
    try {
      const res = await fetch(`${API_BASE}/request-sms-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to send code");
      setSent(true);
    } catch (e) {
      setError(e.message);
    }
  };

  const verify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE}/mfa/sms-verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, sessionId, code }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Verification failed");
      localStorage.setItem("token", data.token);
      localStorage.removeItem("mfa_email");
      localStorage.removeItem("mfa_session");
      localStorage.removeItem("mfa_totpSetup");
      navigate("/dashboard");
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 420, margin: "40px auto", padding: 24 }}>
      <h1 style={{ textAlign: "center" }}>Two-Factor Authentication</h1>
      <p style={{ color: "#475569" }}>
        We'll text a 6-digit code to your phone number.
      </p>
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <button
          onClick={sendCode}
          disabled={sent}
          style={{
            padding: 10,
            background: sent ? "#94a3b8" : "#2563eb",
            color: "#fff",
            border: 0,
            borderRadius: 6,
            cursor: sent ? "default" : "pointer",
          }}
        >
          {sent ? "Code sent" : "Send code"}
        </button>
      </div>
      <form
        onSubmit={verify}
        style={{ display: "flex", flexDirection: "column", gap: 12 }}
      >
        <input
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={6}
          placeholder="123456"
          value={code}
          onChange={(e) =>
            setCode(e.target.value.replace(/[^0-9]/g, "").slice(0, 6))
          }
          required
          style={{
            padding: 12,
            fontSize: 18,
            letterSpacing: 6,
            textAlign: "center",
            border: "1px solid #cbd5e1",
            borderRadius: 6,
          }}
        />
        <button
          type="submit"
          disabled={loading || code.length !== 6}
          style={{
            padding: 12,
            background: "#2563eb",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          {loading ? "Verifying…" : "Verify"}
        </button>
      </form>
      {error && <div style={{ color: "#b91c1c", marginTop: 10 }}>{error}</div>}
    </div>
  );
}
